// @flow

import React from 'react'
import { compose } from 'recompose'
import { Trans, withI18n } from '@lingui/react'

import withStyles from 'material-ui/styles/withStyles'
import Grid from 'material-ui/Grid'
import Typography from 'material-ui/Typography'

import Section from 'components/Section'

type Props = {
  classes: Object,
  i18n: Object,
}

const KorakiSection = ({ classes, i18n }: Props) => (
  <Section className={classes.root} anchor={i18n._('koraki.slug')}>
    <Grid className={classes.container} container spacing={0}>
      <Grid className={classes.intro} item xs={12} sm={12} md={7} lg={7}>
        <Typography className={classes.title} variant={'headline'}>
          <Trans id='koraki.title' />
        </Typography>
        <Typography className={classes.lead} variant={'subheading'}>
          <Trans id='koraki.lead' />
        </Typography>
      </Grid>
      <Grid className={classes.list} item xs={12} sm={12} md={5} lg={5}>
        <Typography className={classes.paragraph} variant={'body1'}>
          <img
            className={classes.image}
            src={require('./images/1.svg')}
            alt={i18n._('koraki.item1')}
          />
          <Trans id='koraki.item1' />
        </Typography>
        <Typography className={classes.paragraph} variant={'body1'}>
          <img
            className={classes.image}
            src={require('./images/2.svg')}
            alt={i18n._('koraki.item2')}
          />
          <Trans id='koraki.item2' />
        </Typography>
        <Typography className={classes.paragraph} variant={'body1'}>
          <img
            className={classes.image}
            src={require('./images/3.svg')}
            alt={i18n._('koraki.item3')}
          />
          <Trans id='koraki.item3' />
        </Typography>
        <Typography className={classes.paragraph} variant={'body1'}>
          <img
            className={classes.image}
            src={require('./images/4.svg')}
            alt={i18n._('koraki.item4')}
          />
          <Trans id='koraki.item4' />
        </Typography>
        <Typography className={classes.paragraph} variant={'body1'}>
          <img
            className={classes.image}
            src={require('./images/5.svg')}
            alt={i18n._('koraki.item5')}
          />
          <Trans id='koraki.item5' />
        </Typography>
      </Grid>
    </Grid>
  </Section>
)

const styles = theme => ({
  root: {
    backgroundColor: '#f2f2f2',
    textAlign: 'center',
    [theme.breakpoints.up('md')]: {
      textAlign: 'left',
    },
  },
  container: {
    maxWidth: '1640px',
    margin: '0 auto',
  },

  intro: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-start',
  },
  title: {
    textAlign: 'inherit',
    marginBottom: theme.spacing.unit * 4,
    maxWidth: '720px',
  },
  lead: {
    textAlign: 'inherit',
    marginBottom: theme.spacing.unit * 4,
    maxWidth: '720px',
  },

  list: {
    //
  },
  paragraph: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    textAlign: 'left',
    marginTop: theme.spacing.unit * 4,
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  image: {
    width: '70px',
    height: '70px',
    marginRight: theme.spacing.unit * 3,
  },
})

export default compose(
  withI18n(),
  withStyles(styles),
)(KorakiSection)



// WEBPACK FOOTER //
// ./src/components/Koraki/index.js